import {
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Grid,
    InputAdornment,
    TextField,
    useMediaQuery,
} from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import { AddComa, awaitWithLoading } from '../../../services/utils'
import { OptionalTag } from '../../Core/OptionalTag'
import {
    SectionSelect,
    SectionSlider,
    SectionSpecialSelect,
    SectionTria,
} from '../../Core/Form/FormComponents'
import { SessionContextStore } from '../../../context/SessionContext'
import {
    BuyingInsuranceContextStore,
    OFFERS_ACTIONS,
} from '../../../context/BuyingInsuranceContext'
import DataLayerService from '../../../services/DataLayerService'
import { Action } from '../../../models/Action'
import { BackButton } from '../../Core/Buttons/BackButton'
import { ContinueButton } from '../../Core/Buttons/ContinueButton'
import { ReactComponent as ShieldSvg } from '../../../assets/shield_with_x.svg'
import {
    EventEmitterService,
    EventKey,
} from '../../../services/EventEmitterService'
import { PlansAndDurationSelect } from '../../Core/PlansAndDurationSelect'
import coveragesApi from '../../../api/coverages.api'
import { SkywatchDialog } from '../../PopUps/SkywatchDialog'
import { ElevatedCircle } from '../../Core/ElevatedCircle'
import NewFillButton from '../../Core/NewFillButton'
import { COVERAGE_TYPES } from '../../../models/insurance-models/CoverageType'
import { UserApi } from '../../../api/user.api'
import { NOT_COVERED_PER_PASS_LIABILITY_ID,BLACKLIST_COVERAGE_OPTIONS_AIRCRAFT_DAMAGE_LIABILITY } from '../../../Constants'
import { BottomSheetPolicySummary } from '../../Insurance/BottomSheetPolicySummary'
import { BrowserView, MobileView } from 'react-device-detect'
import { useHistory, useParams } from 'react-router-dom'
import {
    FirebaseService,
    FirebaseConfigKey,
} from '../../../services/FirebaseService'

interface HullManageProps {
    insurance: ActiveInsuranceModel;
}

export const ModifyPolicyOld = ({insurance, close,modificationObject}) => {
    let { insuranceId } = useParams()
    const [aircraftDamageLiabilityOptions, setAircraftDamageLiabilityOptions] =
        React.useState([])
    const sessionContext = React.useContext(SessionContextStore)
    const offersContext = React.useContext(BuyingInsuranceContextStore)
    const [timer, setTimer] = React.useState(null)
    const [midtermPrice, setMidtermPrice] = React.useState(0.0)
    const [showReferPopup, setShowReferPopup] = React.useState({
        open: false,
        reason: '',
    })
    const [open, setOpen] = React.useState(false)
    const [isAgree, setIsAgree] = React.useState(true)
    const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))
    const history = useHistory()
    const [updatePolicyButton, setUpdatePolicyButton] = React.useState()
    const [initialAircraftDamageValue, setInitialAircraftDamageValue] =
        React.useState(
            modificationObject.offer.liability.liability
        )
    const changeDelay = (change) => {
        if (timer) {
            clearTimeout(timer)
            setTimer(null)
        }
        setTimer(
            setTimeout(() => {
                onPolicyFieldChange('additional_insured', change)
            }, 500)
        )
    }

    React.useEffect(() => {
        const calcOptionsAircraftDamageLiability = async () => {
            let options = modificationObject.liabilityLimitOptions
            let selectedOption = modificationObject.liabilityLimitOptions.find(
                    (obj) =>
                        obj.value ===
                        modificationObject.liabilityLimitSelected
                )
            setInitialAircraftDamageValue(
                selectedOption.label
            )
            const value = selectedOption.label.replace(/[:, ]/g, '')
            if(modificationObject.billingPeriod != 'Annual' && !BLACKLIST_COVERAGE_OPTIONS_AIRCRAFT_DAMAGE_LIABILITY.includes(value)){
                options = options.filter(x=>!BLACKLIST_COVERAGE_OPTIONS_AIRCRAFT_DAMAGE_LIABILITY.includes(x.label))
            }
            var index =
                modificationObject.liabilityLimitOptions.findIndex(
                    (obj) =>
                        obj.value ===
                        modificationObject.liabilityLimitSelected
                )
            options = options.slice(index)
            
            onPolicyFieldChange(
                'aircraft_damage_liability',
                modificationObject.liabilityLimitSelected
            )

            if(sessionContext.user.userInsuredPersons[0]?.pilot_certification.toLowerCase() === "student" && modificationObject.billingPeriod === 'Annual'){
                const index = options.findIndex(obj => obj.label === "$100000")
                options = index !== -1 ? options.slice(0, index + 1) : options
            }
            setAircraftDamageLiabilityOptions(options)
        }
        calcOptionsAircraftDamageLiability()
    }, [])

    React.useEffect(() => {
        if (
            offersContext.offerCart.bodily_injury_liability ==
            NOT_COVERED_PER_PASS_LIABILITY_ID
        ) {
            setIsAgree(false)
            setOpen(true)
        } else {
            setIsAgree(true)
            setOpen(false)
        }
    }, [offersContext.offerCart.bodily_injury_liability])

    React.useEffect(() => {
        if (updatePolicyButton) {
            calcMidtermPrice()
        }
    }, [offersContext.pricebreakdown.price])

    const calcMidtermPrice = async () => {
        let res = await awaitWithLoading(
            coveragesApi.calcMidtermPrice(offersContext.offerId, insuranceId)
        )
        if (res.ok) {
            setMidtermPrice(res.data)
        } else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    const onPolicyFieldChange = (name, value) => {
        var newValue = offersContext.options.aircraft_damage_liability.find(
            (obj) => obj.value === value
        )
        if (newValue.label === initialAircraftDamageValue.replace(',', '')) {
            setUpdatePolicyButton(false)
        } else {
            setUpdatePolicyButton(true)
        }
        let changed = { ...offersContext.offerCart }
        let pricebreakdown = { ...offersContext.pricebreakdown }
        changed[name] = value
        if (name === 'period') {
            if (
                changed['period'].plan == 'Day' ||
                changed['period'].plan == 'Week'
            )
                pricebreakdown.autoRenew = false
            else pricebreakdown.autoRenew = true
        }
        offersContext.dispatch(new Action('CART_CHANGED', changed))
        offersContext.dispatch(
            new Action('PRICE_BREAKDOWN_CHANGED', pricebreakdown)
        )
    }

    const onReferUnderwriterCommentsChange = (event) => {
        offersContext.dispatch(
            new Action(OFFERS_ACTIONS.REFER_COMMENTS, event.target.value)
        )
    }

    const getCoverageTooltip = (coverageName) => {
        if (coverageName == 'tria') {
            return 'Affords insurance in compliance with and to the extend required by the provisions of the federal Terrorism Rick Insurance Act of 2002, as amended.'
        } else if (coverageName == 'aircraft_damage_liability') {
            return "The Physical Damage to Non-Owned Aircraft coverage includes 'Loss of Use' of a non-owned aircraft, for which you are legally liable. The 'Loss of Use' limit of liability is included within the 'Damage Limit'. You must select a Damage Limit or decline this coverage to continue."
        }
        let value = offersContext.options[coverageName]
        return value && value.length > 1 ? value[0].tooltip : undefined
    }


    const handleDisagree = () => {
        setIsAgree(false)
        setOpen(false)
    }

    const handleAgree = async () => {
        setIsAgree(true)
        setOpen(false)
    }

    const onMidTermAccept = async () => {
        DataLayerService.pushToDataLayer({
            event: 'liability-increased-button-clicked',
        })
        var res = await awaitWithLoading(
            coveragesApi.bindMidtermOffer(offersContext.offerId, insuranceId)
        )
        if (res.ok) {
            EventEmitterService.dispatch(EventKey.ShowSuccess, {
                title: 'Liability has been increased',
                body: 'Your changes have been made. An email will be sent to you with the policy’s updated liability endorsement.',
                onClose: () => {
                    window.location.reload(false)
                },
            })
            DataLayerService.pushToDataLayer({ event: 'mid-term-updated' })
        } else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    return (
        <Container>
            {isMobile ? (
                <SectionSelect
                    name="aircraft_damage_liability"
                    onChange={onPolicyFieldChange}
                    errors={offersContext.offerCardErrors}
                    value={offersContext.offerCart.aircraft_damage_liability}
                    buttons={aircraftDamageLiabilityOptions}
                    tooltip={getCoverageTooltip('aircraft_damage_liability')}
                    subtitle="Insurance coverage that applies to damage that you are legally liable to pay as a result of damage to non-owned aircraft that is in your care."
                />
            ) : (
                <SectionSlider
                    name="aircraft_damage_liability"
                    subtitle={
                        'Insurance coverage that applies to damage that you are legally liable to pay as a result of damage to non-owned aircraft that is in your care.'
                    }
                    value={offersContext.offerCart.aircraft_damage_liability}
                    options={aircraftDamageLiabilityOptions}
                    tooltip={getCoverageTooltip('aircraft_damage_liability')}
                    onChange={(name, value) => {
                        onPolicyFieldChange(
                            name,
                            aircraftDamageLiabilityOptions.find(
                                (opt) => Number(opt.label.slice(1)) == value
                            ).value
                        )
                    }}
                    marks={aircraftDamageLiabilityOptions.map((opt, index) => {
                        if (
                            index ==
                                aircraftDamageLiabilityOptions.length - 1 ||
                            index == 0 ||
                            index ==
                                Math.round(
                                    aircraftDamageLiabilityOptions.length / 2
                                )
                        )
                            return {
                                value: Number(opt.label.slice(1)),
                                label: '$' + AddComa(opt.label.slice(1)),
                            }
                        else
                            return {
                                value: Number(opt.label.slice(1)),
                            }
                    })}
                    min={Number(
                        aircraftDamageLiabilityOptions[0].label.slice(1)
                    )}
                    max={Number(
                        aircraftDamageLiabilityOptions[
                            aircraftDamageLiabilityOptions.length - 1
                        ].label.slice(1)
                    )}
                />
            )}

            {/* <SkywatchDialog
                open={showReferPopup.open}
                closeDialog={() =>
                    setShowReferPopup({ open: false, reason: '' })
                }
                maxWidth={isMobile ? 'md' : 'xs'}
                circleHeader={
                    <ElevatedCircle>
                        {' '}
                        <ShieldSvg className="medium-icon red" />
                    </ElevatedCircle>
                }
                closeTitle={''}
            >
                <div className="text-title blue textcenter bold margin-bottom-basic">
                    Approval Required
                </div>
                <div className="text-small">
                    <div>
                        <span className="bold">Please note: </span> This request
                        requires an approval from the underwriter.
                    </div>
                    <div>
                        <span className="bold">Reason: </span>
                        {showReferPopup.reason}
                    </div>
                </div>
                <br />
                <TextField
                    fullWidth
                    variant="outlined"
                    multiline
                    rows={4}
                    label="comments for the underwriter"
                    InputProps={{
                        onChange: onReferUnderwriterCommentsChange,
                        value: offersContext.referUnderwriterComments,
                        endAdornment: (
                            <InputAdornment>
                                {' '}
                                <OptionalTag />{' '}
                            </InputAdornment>
                        ),
                    }}
                />
                <br />
                <FlexView vAlignContent={'center'} hAlignContent={'center'}>
                    <div
                        onClick={() =>
                            setShowReferPopup({ open: false, reason: '' })
                        }
                        className="text-small black underline clickable margin-right-basic"
                    >
                        Cancel
                    </div>
                </FlexView>
            </SkywatchDialog>
            <BrowserView>
                <FlexView vAlignContent={'center'} hAlignContent={'center'}>
                    {updatePolicyButton && (
                        <div>
                            Your Midterm Change Price :{' '}
                            {FirebaseService.getValue(
                                FirebaseConfigKey.CURRENCY_SYMBOL
                            )}
                            {midtermPrice.toFixed(2)}
                        </div>
                    )}
                </FlexView>
                <FlexView vAlignContent={'center'} hAlignContent={'center'}>
                    <br />
                    {updatePolicyButton && (
                        <NewFillButton
                            className="update-button"
                            onClick={onMidTermAccept}
                        >
                            Increase Liability
                        </NewFillButton>
                    )}
                </FlexView>
            </BrowserView> */}
        </Container>
    )
}
